import {useState} from "react";
import {css} from "@emotion/react";

import {onDesktop, p} from "@pg-design/helpers-css";
import {IInfiniteScrollItemProps, IInfiniteScrollListProps, InfiniteScrollList, useInfiniteList} from "@pg-design/infinite-list";
import {SystemModal} from "@pg-design/modal-module";

import {IPropertyListProperty} from "../../../property/types/PropertyListProperty";
import {useAppDispatch} from "../../../store/hooks";
import {IAmplitudeItemListContext} from "../../../tracking/amplitude/get_amplitude_view_item_event_properties";
import {IUseOfferDetailPropertiesQuery} from "../../hooks/use_offer_modal_properties";
import {loadNextPage} from "../../state/offer_modals_slice";
import {IOfferBoxGTMSource} from "../../types/IOfferBoxGTMSource";
import {IOfferModalName} from "../../types/OfferModalName";
import {IOfferModalOffer} from "../../types/OfferModalOffer";
import {OfferModalPropertiesList} from "./properties_list/OfferModalPropertiesList";
import {OfferModalPropertiesListItem} from "./properties_list/OfferModalPropertiesListItem";

interface IProps {
    modalName: IOfferModalName;
    propertiesQuery: IUseOfferDetailPropertiesQuery;
    offer: IOfferModalOffer;
    intersectionContainerId: string;
    trackingMeta: {
        listName: string;
        listId: string;
        source: IOfferBoxGTMSource;
    };
    amplitudeItemListContext?: IAmplitudeItemListContext | null;
}

export function OfferModalTilesList(props: IProps) {
    const {trackingMeta, modalName, propertiesQuery, offer, intersectionContainerId, amplitudeItemListContext} = props;

    const dispatch = useAppDispatch();
    const [isIntersecting, setIsIntersecting] = useState(false);
    const infiniteList = useInfiniteList(
        propertiesQuery.queryData,
        () => {
            dispatch(loadNextPage({modalName}));
        },
        isIntersecting,
        propertiesQuery.isUninitialized
    );

    return (
        <SystemModal.Content css={resetPaddingOnDesktop}>
            <InfiniteScrollList
                listComponent={OfferModalPropertiesList}
                itemComponent={getItemComponent(offer, trackingMeta, amplitudeItemListContext)}
                infiniteList={infiniteList}
                listIntersectionContainerId={intersectionContainerId}
                handleIsIntersecting={(isIntersecting) => {
                    setIsIntersecting(isIntersecting);
                }}
            />
        </SystemModal.Content>
    );
}
/*
    Utils
 */
function getItemComponent(
    offer: IOfferModalOffer,
    trackingMeta: IProps["trackingMeta"],
    amplitudeItemListContext: IProps["amplitudeItemListContext"]
): IInfiniteScrollListProps<IPropertyListProperty>["itemComponent"] {
    return (props: IInfiniteScrollItemProps<IPropertyListProperty>) => {
        const {item, index} = props;

        return (
            <OfferModalPropertiesListItem
                property={item}
                offer={offer}
                index={index}
                trackingMeta={trackingMeta}
                amplitudeItemListContext={amplitudeItemListContext}
            />
        );
    };
}

/*
    Styles
 */
const resetPaddingOnDesktop = css`
    ${onDesktop(css`
        ${p(0)}
    `)}
`;
import {useState} from "react";
import {css} from "@emotion/react";

import {onDesktop, p} from "@pg-design/helpers-css";
import {IInfiniteScrollItemProps, IInfiniteScrollListProps, InfiniteScrollList, useInfiniteList} from "@pg-design/infinite-list";
import {SystemModal} from "@pg-design/modal-module";

import {IPropertyListProperty} from "../../../property/types/PropertyListProperty";
import {useAppDispatch} from "../../../store/hooks";
import {IAmplitudeItemListContext} from "../../../tracking/amplitude/get_amplitude_view_item_event_properties";
import {IUseOfferDetailPropertiesQuery} from "../../hooks/use_offer_modal_properties";
import {loadNextPage} from "../../state/offer_modals_slice";
import {IOfferBoxGTMSource} from "../../types/IOfferBoxGTMSource";
import {IOfferModalName} from "../../types/OfferModalName";
import {IOfferModalOffer} from "../../types/OfferModalOffer";
import {OfferModalPropertiesList} from "./properties_list/OfferModalPropertiesList";
import {OfferModalPropertiesListItem} from "./properties_list/OfferModalPropertiesListItem";

interface IProps {
    modalName: IOfferModalName;
    propertiesQuery: IUseOfferDetailPropertiesQuery;
    offer: IOfferModalOffer;
    intersectionContainerId: string;
    trackingMeta: {
        listName: string;
        listId: string;
        source: IOfferBoxGTMSource;
    };
    amplitudeItemListContext?: IAmplitudeItemListContext | null;
}

export function OfferModalTilesList(props: IProps) {
    const {trackingMeta, modalName, propertiesQuery, offer, intersectionContainerId, amplitudeItemListContext} = props;

    const dispatch = useAppDispatch();
    const [isIntersecting, setIsIntersecting] = useState(false);
    const infiniteList = useInfiniteList(
        propertiesQuery.queryData,
        () => {
            dispatch(loadNextPage({modalName}));
        },
        isIntersecting,
        propertiesQuery.isUninitialized
    );

    return (
        <SystemModal.Content css={resetPaddingOnDesktop}>
            <InfiniteScrollList
                listComponent={OfferModalPropertiesList}
                itemComponent={getItemComponent(offer, trackingMeta, amplitudeItemListContext)}
                infiniteList={infiniteList}
                listIntersectionContainerId={intersectionContainerId}
                handleIsIntersecting={(isIntersecting) => {
                    setIsIntersecting(isIntersecting);
                }}
            />
        </SystemModal.Content>
    );
}
/*
    Utils
 */
function getItemComponent(
    offer: IOfferModalOffer,
    trackingMeta: IProps["trackingMeta"],
    amplitudeItemListContext: IProps["amplitudeItemListContext"]
): IInfiniteScrollListProps<IPropertyListProperty>["itemComponent"] {
    return (props: IInfiniteScrollItemProps<IPropertyListProperty>) => {
        const {item, index} = props;

        return (
            <OfferModalPropertiesListItem
                property={item}
                offer={offer}
                index={index}
                trackingMeta={trackingMeta}
                amplitudeItemListContext={amplitudeItemListContext}
            />
        );
    };
}

/*
    Styles
 */
const resetPaddingOnDesktop = css`
    ${onDesktop(css`
        ${p(0)}
    `)}
`;
